import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTwitter, faInstagram, faTiktok, faSnapchat, faFacebookF, faApple } from '@fortawesome/free-brands-svg-icons';
import { AndroidFilled, AndroidOutlined, AppleFilled, AppleOutlined } from '@ant-design/icons';
import { Divider, Flex } from 'antd'
import mastercard from './assets/images/mastercard.jpg';
import paypal from './assets/images/paypal.jpg';
import ebay from './assets/images/ebay.jpg';
import gpay from './assets/images/gpay.jpg';
import ae from './assets/images/ae.jpg';
import monobank from './assets/images/monobank.jpg';
import discover from './assets/images/discover.jpg';
import wu from './assets/images/wu.jpg';
import payoneer from './assets/images/payoneer.jpg';
import applepay from './assets/images/applepay.jpg';
import amazon from './assets/images/amazon.jpg';
import alipay from './assets/images/alipay.jpg';
import bitpay from './assets/images/bitpay.jpg';
import bitcoin from './assets/images/bitcoin.jpg';


const Footer = () => {
    return (
        <footer className="footer">
            <div className="container mt-5">
                <div className="row">
                    <div className="col-md-6 mobile-footer-hide" >
                        <div className="row">
                            <div className="col-md-4 mb-md-0 mb-4">
                                <h6 className="footer-heading">COMPANY INFO</h6>
                                <ul className="list-f ps-0">
                                    <li><a href="#" className="py-1 d-block">About</a></li>
                                    <li><a href="#" className="py-1 d-block">Social Responsibility</a></li>
                                    <li><a href="#" className="py-1 d-block">Afiliate</a></li>
                                    <li><a href="#" className="py-1 d-block">Fashion Blogger</a></li>
                                </ul>
                            </div>
                            <div className="col-md-4 mb-md-0 mb-4">
                                <h6 className="footer-heading">HELP & SUPPORT</h6>
                                <ul className="list-f ps-0">
                                    <li><a href="#" className="py-1 d-block">Shipping info</a></li>
                                    <li><a href="#" className="py-1 d-block">Returns</a></li>
                                    <li><a href="#" className="py-1 d-block">How to Order</a></li>
                                    <li><a href="#" className="py-1 d-block">How to Track</a></li>
                                    <li><a href="#" className="py-1 d-block">Size Chart</a></li>
                                </ul>
                            </div>
                            <div className="col-md-4 mb-md-0 mb-4">
                                <h6 className="footer-heading">CUSTOMER CARE</h6>
                                <ul className="list-f ps-0">
                                    <li><a href="#" className="py-1 d-block">Contact Us</a></li>
                                    <li><a href="#" className="py-1 d-block">Payment</a></li>
                                    <li><a href="#" className="py-1 d-block">Bonus Point</a></li>
                                    <li><a href="#" className="py-1 d-block">Notices</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row justify-content-between mobile-footer">
                            <div className="col-sm-4 col-md-12 col-lg-6 mb-md-0 mb-4 fit-content">
                                <h2 className="footer-heading">SOCIALS</h2>
                                <ul className="footer-social p-0 d-flex">
                                    <li className="f-icon"><FontAwesomeIcon icon={faFacebookF} /></li>
                                    <li className="f-icon"><FontAwesomeIcon icon={faTwitter} /></li>
                                    <li className="f-icon"><FontAwesomeIcon icon={faInstagram} /></li>
                                    <li className="f-icon"><FontAwesomeIcon icon={faTiktok} /></li>
                                    <li className="f-icon"><FontAwesomeIcon icon={faSnapchat} /></li>
                                </ul>
                            </div>
                            <div className="col-sm-4 col-md-12 col-lg-4 mb-md-0 mb-4 text-end fit-content"  >
                                <h2 className="footer-heading">PLATFORMS</h2>
                                <ul className="footer-social p-0 d-flex justify-content-end">
                                    <li className="filled-icon"><AndroidFilled className="fs-4" /></li>
                                    <li className="filled-icon"><AppleFilled className="fs-4" /></li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-sm-12 col-md-12 col-lg-12 mb-md-0 my-4">
                            <div className="row align-items-center justify-content-align">
                                <div className="col-lg-9 col-sm-12 px-1">
                                    <h2 className="footer-heading ">SIGN UP</h2>
                                    <form action="#" className="subscribe-form">
                                        <div className="form-group-lg">
                                            <input type="text" className="form-control rounded-0" placeholder="Your email" />&nbsp;
                                        </div>
                                    </form>
                                </div>
                                <div className="col-lg-3 col-sm-12 px-1">
                                    <div className="form-group-lg">
                                        <input type="submit" value="SUBSCRIBE" className="form-control submit px-3 rounded-0 bg-dark text-white" />
                                    </div>
                                </div>
                                <span className="subscribe-tag">By clicking the SUBSCRIBE button, you are agreeing to our <a href="#" className="fw-bolder">Privacy & Cookie Policy</a></span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row my-5 margin-sm">
                    <div className="col-md-6 col-lg-6">
                        <p className="copyright mb-2">
                            &copy; 2010 - 2022 ALL RIGHTS RESERVED
                        </p>
                        <div className="mb-2 list">
                            <a className="pe-2 f-links" href="#">Privacy Center</a>
                            <span> <Divider type="vertical" /></span>
                            <a className="pe-2 f-links" href="#">Privacy & Cookie Policy</a>
                            <span> <Divider type="vertical" /></span>
                            <a className="pe-2 f-links" href="#">Manage Cookie</a>
                            <span> <Divider type="vertical" /></span>
                        </div>
                        <div className="mb-2 list">
                            <a className="pe-2 f-links" href="#">Terms & Conditions</a>
                            <span> <Divider type="vertical" /></span>
                            <a className="pe-2 f-links" href="#">Copyright Notice</a>
                            <span> <Divider type="vertical" /></span>
                            <a className="pe-2 f-links" href="#">Imprint</a>
                            <span> <Divider type="vertical" /></span>
                        </div>
                    </div>

                    <div className="col-md-6 col-lg-6 mobile-footer-hide">
                        <Flex wrap="wrap" gap="small">
                            <img src={mastercard} alt="mastercard" className="img-fluid" height="55px" width="55px" />
                            <img src={paypal} alt="mastercard" className="img-fluid " height="55px" width="55px" />
                            <img src={ebay} alt="mastercard" className="img-fluid " height="55px" width="55px" />
                            <img src={gpay} alt="mastercard" className="img-fluid " height="55px" width="55px" />
                            <img src={monobank} alt="mastercard" className="img-fluid " height="55px" width="55px" />
                            <img src={discover} alt="mastercard" className="img-fluid " height="55px" width="55px" />
                            <img src={wu} alt="mastercard" className="img-fluid " height="55px" width="55px" />
                            <img src={payoneer} alt="mastercard" className="img-fluid " height="55px" width="55px" />
                        </Flex>
                        <Flex wrap="wrap" gap="small" className="my-2">
                            <img src={applepay} alt="mastercard" className="img-fluid " height="55px" width="55px" />
                            <img src={ae} alt="mastercard" className="img-fluid " height="55px" width="55px" />
                            <img src={amazon} alt="mastercard" className="img-fluid " height="55px" width="55px" />
                            <img src={alipay} alt="mastercard" className="img-fluid " height="55px" width="55px" />
                            <img src={bitpay} alt="mastercard" className="img-fluid " height="55px" width="55px" />
                            <img src={bitcoin} alt="mastercard" className="img-fluid " height="55px" width="55px" />
                        </Flex>
                    </div>

                </div>

            </div>
        </footer>
    )
}

export default Footer;